<dl-device-status-cell
    *ngIf="!!item"
    [deviceStatusType]="item.deviceStatusType"
    [deviceCategory]="item.category"
    [tooltipDirection]="tooltipDirection"
>
</dl-device-status-cell>
